import Carousel from 'react-bootstrap/Carousel';
function Screenshot(props) {
    return (
        <Carousel.Item {...props}>
            <figure className="figure d-block">
                <img className="figure-img d-block w-75 mx-auto"
                     src={props.item.src}
                     alt={props.item.text} />
                    <figcaption className="figure-caption text-center text-light">
                        {props.item.text}
                    </figcaption>
            </figure>
            {/*<img*/}
            {/*    className="d-block w-75 mx-auto"*/}
            {/*    src={props.item.src}*/}
            {/*    alt={props.item.text}*/}
            {/*/>*/}
            {/*<Carousel.Caption>*/}
            {/*    <h2>{props.item.text}</h2>*/}
            {/*</Carousel.Caption>*/}
        </Carousel.Item>
    )
}

export default Screenshot;